import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/serie';
import Serie from './Serie';


const ms2p = (state) => {
    return {
        ...state.inv_serie,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Serie);